<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
                @search-change="searchChange" @refresh-change="refreshChange" @row-save="handleSave"
                @row-update="handleUpdate" @selection-change="handleSelectionChange" @size-change="pageSizeChange"
                @current-change="pageChange">
                <template slot-scope="scope" slot="menuLeft">
                    <el-button type="primary" icon="el-icon-plus" size="small" plain @click.stop="handleAdd()">新增
                    </el-button>
                    <el-button type="danger" icon="el-icon-delete" size="small" plain
                        @click.stop="handleDel('DELETE_OPTION', '物理删除')">物理删除
                    </el-button>
                </template>
                <template slot-scope="scope" slot="menu">
                    <el-button type="primary" icon="el-icon-edit" size="small" plain
                        @click.stop="handleEdit(scope.row, scope.index)">编辑
                    </el-button>
                    <el-button type="danger" icon="el-icon-delete" size="small" plain
                        @click.stop="handleDelSingle(scope.row, scope.index)">删除
                    </el-button>
                </template>
                <template slot-scope="scope" slot="certificateForm">
                    <fileUpload :in-table="false" :show-plus-and-del="true" action="#" :limit="1"
                        :uploaded-images="scope.row.certificate" @uploaded="handleUploaded" />
                </template>
                <template slot-scope="scope" slot="certificate">
                    <viewer :images="formmaterImage(scope.row.certificate)" v-if="isImage(scope.row.certificate)">
                        <img v-for="src in formmaterImage(scope.row.certificate)" :src="src" :key="src" width="30" />
                    </viewer>
                    <i v-else @click="downloadFile(scope.row.certificate)" class="el-icon-download">下载</i>
                    <!-- <span v-else>{{ isFile(scope.row.certificate) ? scope.row.certificate.split('.').pop() : scope.row.certificate}}</span> -->
                </template>
            </avue-crud>
        </basic-container>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { payConfigOption } from "@/const/work/payConfigOption";
import {
    findPayList,
    addPay,
    editPay,
    delPay,
} from "@/api/work/payConfig";
import { findByLabel, parseParam } from "@/util/util";
import { DIC } from "@/const/dic";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import VueQr from "vue-qr";
import oss from "ali-oss";
import md5 from "js-md5";
import fileUpload from "@/components/fileUpload/fileUpload";
export default {
    name: "stuff",
    components: {
        fileUpload,
        VueQr
    },
    data() {
        return {
            tableOption: payConfigOption, //表格设置属性
            tableData: [], //表格的数据
            tablePage: 1,
            tableLoading: false,
            dialogFormVisible: false,
            tabelObj: {},
            time: "",
            stuffIds: "",
            dismissReason: "",
            currentStatus: [],
            changeStatus: [],
            jobStatus: [],
            page: {
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 10, //每页显示多少条
            },
            grade: {
                box: false,
                check: [],
            },
            form: {
                //人员变动
                delivery: false,
                reason: "",
                type: [],
                dismissReason: "",
                resource: "",
                desc: "",
            },
            departs: [],
            depart: [],
            listTypeMode: "picture-card",
            certificate: "", //上传的支付配置
            uploadedFile: "", // 上传的文件地址
            fileList1: [], // 上传文件列表
            conttent: "", //富文本
            dialogFormVisible1: false,
            content: "",
        };
    },
    created() {
        this.handleList();
    },
    watch: {},
    mounted() { },
    computed: {
        ...mapGetters(["permission"]),
    },
    props: [],
    methods: {
        downloadFile(fileUrl) {
            // 打开文件 URL 在新窗口中
            window.open(fileUrl, '_blank');
        },
        isImage(url) {
            return /\.(jpg|jpeg|png|gif|bmp)$/i.test(url);
        },
        isFile(url) {
            // 判断是否为非图片的其他格式文件
            return /\.(?!jpg|jpeg|png|gif|bmp)$/i.test(url);
        },
        handleUploaded(urls) {
            if (urls.length > 0) {
                this.certificate = urls[0].url;
            } else {
                this.certificate = "";
            }
            this.tableLoading = false;
        },
        formmaterImage(row) {
            let str = new Array();
            if (row != null) {
                let picArray = row.split(",");
                for (let i = 0; i < picArray.length; i++) {
                    str.push(picArray[i]);
                }
            }
            return str;
        },
        //状态改变确定按钮
        changeStuff() {
            console.log(this);
            /**
             *多选时传参
             **/
            let stuffIds = new Array();
            for (let row of this.$refs.crud.tableSelect) {
                stuffIds.push(row.id);
            }
            stuffIds.push(this.stuffIds);
            const removeDuplicateItems = (arr) => [...new Set(arr)]; //去重
            stuffIds = removeDuplicateItems(stuffIds);
            let jobStatus =
                this.changeStatus == "离职"
                    ? "DISMISSION"
                    : this.changeStatus == "转正"
                        ? "ON_JOB"
                        : "";
            this.dismissReason = this.dismissReason.replace(/(^\s+)|(\s+$)/g, "");
            let params = {
                time: this.time,
                jobStatus,
                dismissReason: this.dismissReason,
            };
            params = parseParam(params);
            console.log(params);
            if (this.changeStatus == "离职" && this.dismissReason == null) {
                this.$message({
                    showClose: false,
                    message: "请填写离职理由",
                    type: "error",
                });
            } else if (jobStatus == "") {
                console.log("请选择变动类型");
                this.$message({
                    showClose: false,
                    message: "请选择变动类型",
                    type: "error",
                });
            } else if (this.time == null) {
                this.$message({
                    showClose: false,
                    message: "请选择变动时间",
                    type: "error",
                });
            }

            if (this.changeStatus == "转正" && this.time) {
                this.dialogFormVisible = false;
            } else if (
                this.changeStatus == "离职" &&
                this.dismissReason &&
                this.time
            ) {
                this.dialogFormVisible = false;
            }
        },
        pageSizeChange(pageSize) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            (params.page = this.page.currentPage), (params.size = pageSize);
            findPayList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: pageSize,
                };
                this.tableLoading = false;
            });
        },
        pageChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page;
            params.size = this.page.pageSize;
            findPayList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page,
                    pageSize: this.page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        searchChange(params) {
            this.tableLoading = true;
            // let params = this.$refs.crud.searchForm
            params.page = this.page.currentPage;
            params.size = this.page.pageSize;
            findPayList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: params.page,
                    pageSize: params.size,
                };
                this.tableLoading = false;
            });
        },
        refreshChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page.currentPage;
            params.size = page.pageSize;
            findPayList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page.currentPage,
                    pageSize: page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        clean() {
            this.depart = [];
            this.certificate = "";
            this.fileList1 = [];
        },
        /**
         * @title 打开新增窗口
         * @detail 调用crud的handleadd方法即可
         *
         **/
        handleAdd() {
            this.clean();
            this.$refs.crud.rowAdd();
        },
        handleEdit(row, index) {
            this.clean();
            this.certificate = row.certificate;
            this.$refs.crud.rowEdit(row, index);
        },
        /**
         * @title 获取数据
         * @detail 赋值为tableData表格即可
         *
         **/
        handleList() {
            this.tableLoading = true;
            let parmas = {
                page: this.page.currentPage,
                size: this.page.pageSize,
            };
            findPayList(parmas).then((res) => {
                console.log('res::: ', res);
                let data = JSON.parse(res.data);
                console.log('data::: ', data);
                this.tableData = data.rows;
                console.log(this.tableData);
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        /**
         * @title 当前选中的数据
         * @param val 选中的值
         *
         **/
        handleSelectionChange() { },

        // 文件大小和类型检查
        handleBeforeUpload(file) {
            const isValidType = /\.(jpg|jpeg|png|gif|bmp|pdf|doc|docx|xls|xlsx)$/i.test(file.name);
            const isValidSize = file.size / 1024 / 1024 < 5; // 文件大小限制为 5MB

            if (!isValidType) {
                this.$message.error('仅支持 jpg/png/pdf/doc/xls 等格式的文件');
                return false;
            }
            if (!isValidSize) {
                this.$message.error('文件大小不能超过 5MB');
                return false;
            }
            return true;
        },
        // 删除文件
        handleRemoveFile(index) {
            // 从文件列表中删除文件
            this.fileList1.splice(index, 1);
            this.$message.success("文件已删除");
        },

        // 文件上传请求
        fnUploadcertificate(option) {
            this.tableLoading = true;
            getAliyunPublicToken().then((res) => {
                let data = JSON.parse(res.data);
                let client = new oss({
                    region: data.point,
                    endPoint: data.point,
                    accessKeyId: data.accessKeyId,
                    accessKeySecret: data.accessKeySecret,
                    Expiration: data.expiration,
                    bucket: data.bucketName,
                    stsToken: data.securityToken,
                });
                const storeAs = md5(option.file.name + new Date().getTime()) + '.' + option.file.name.split('.').pop();
                client
                    .multipartUpload(storeAs, option.file, {})
                    .then((results) => {
                        const uploadedUrl = results.res.requestUrls[0];
                        const urlWithoutQuery = uploadedUrl.split("?")[0]; // 去掉查询参数

                        // 上传成功后将文件添加到文件列表
                        this.fileList1.push({
                            name: option.file.name,
                            url: urlWithoutQuery,
                        });

                        console.log("文件上传成功：", this.fileList1);
                        this.tableLoading = false;
                    })
                    .catch((err) => {
                        console.error("上传失败：", err);
                        this.tableLoading = false;
                    });
            });
        },
        /**
         * @title 数据添加
         * @param row 为当前的数据
         * @param done 为表单关闭函数
         *
         **/

        guid2() {
            function S4() {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            }
            return (
                S4() +
                S4() +
                "-" +
                S4() +
                "-" +
                S4() +
                "-" +
                S4() +
                "-" +
                S4() +
                S4() +
                S4()
            );
        },
        base64ImgtoFile(image, name) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    canvas.getContext("2d").drawImage(img, 0, 0);
                    canvas.toBlob((blob) => {
                        resolve({
                            name: name,
                            data: blob,
                        });
                    }, "image/png");
                };
                img.onerror = () => {
                    reject(new Error("Failed to load image"));
                };
                img.src = image;
            });
        },
        handleSave(row, done) {
            console.log('row::: ', row);
            row.signType = "MD5";
            row.inputCharset = "UTF-8";
            addPay(row).then((response) => {
                if (response.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "添加成功",
                        type: "success",
                    });
                    this.handleList();
                } else {
                    this.$message({
                        showClose: true,
                        message: response.message,
                        type: "error",
                    });
                }
            }).catch((error) => {
                this.loading = false;
                this.$message({
                    showClose: true,
                    message: error,
                    type: "error",
                });
            });
            done();
        },
        /**
         * @title 数据删除
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         *
         **/
        handleDel(dicName, label) {
            if (this.$refs.crud.tableSelect.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择要操作的数据",
                    type: "error",
                });
                return;
            }

            this.$confirm(`是否确认删除?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let ids = new Array();
                    for (let row of this.$refs.crud.tableSelect) {
                        ids.push(row.id);
                    }
                    console.log(ids);
                    delPay(findByLabel(DIC.DELETE_OPTION, label), ids)
                        .then((response) => {
                            if (response.code == "200") {
                                this.$message({
                                    showClose: true,
                                    message: "删除成功",
                                    type: "success",
                                });
                                this.handleList();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.message,
                                    type: "error",
                                });
                            }
                        })
                        .catch((error) => {
                            this.loading = false;
                            this.$message({
                                showClose: true,
                                message: error,
                                type: "error",
                            });
                        });
                })
                .catch(() => { });
        },
        handleDelSingle(row) {
            console.log('row::: ', row)
            this.$confirm(`是否确认删除?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    delPay("DELETE_OPTION", [row.id])
                        .then((response) => {
                            if (response.code == "200") {
                                this.$message({
                                    showClose: true,
                                    message: "删除成功",
                                    type: "success",
                                });
                                this.handleList();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.message,
                                    type: "error",
                                });
                            }
                        })
                        .catch((error) => {
                            this.loading = false;
                            this.$message({
                                showClose: true,
                                message: error,
                                type: "error",
                            });
                        });
                })
                .catch(() => { });
        },
        /**
         * @title 数据更新
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         * @param done 为表单关闭函数
         *
         **/
        handleUpdate(row, index, done) {
            row.certificate = this.certificate;
            editPay(row)
                .then((response) => {
                    if (response.code == "200") {
                        this.$message({
                            showClose: true,
                            message: "修改成功",
                            type: "success",
                        });
                        this.handleList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: response.message,
                            type: "error",
                        });
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    this.$message({
                        showClose: true,
                        message: error,
                        type: "error",
                    });
                });
            done();
        },
    },
};
</script>

<style lang="scss">
.table-container {
    padding: 8px 10px;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}
.el-icon-download {
    cursor: pointer;
    color: #409eff;
}
</style>